import Tippy from '@tippyjs/react';

import {
  ALERT_BILLER_CLEARINGHOUSE_HINT,
  COMING_SOON_FIELDS
} from 'lib/constants/healthcareProgram/eligibilitySetup';

import Badge from 'components/shared/Badge/Badge';
import Switch from 'components/shared/Switch/Switch';
import Accordion from 'components/shared/Accordion/Accordion';
import Typography from 'components/shared/Typography/Typography';

import renderEligibilityStepContent from '../lib/renderEligibilityStepContent';

const EligibilityStepRow = ({
  step,
  index,
  onUpdate,
  setDisableDragging,
  disableToggle = false
}) => {
  const stepHeader = (
    <div className="flex items-center gap-2" data-qa={`eligibility-step-${step.field}`}>
      <div className="flex size-5 min-h-5 min-w-5 items-center justify-center rounded-full border border-solid border-neutral-300 bg-neutral-200">
        <span className="text-xxs font-500 text-neutral-700">{index + 1}</span>
      </div>
      <Typography
        size="small"
        color={COMING_SOON_FIELDS.includes(step.field) ? 'neutral-500' : 'neutral-900'}
        weight="medium">
        {step.label}
      </Typography>
    </div>
  );

  const stepRightContent = (
    <div className="flex items-center gap-3">
      {step.isAi && (
        <Badge
          text="AI"
          color="primary"
          iconColor="neutral"
          variant="light"
          size="small"
          icon="myscribeai-mono"
          className="px-2"
        />
      )}
      {step.comingSoon && (
        <Badge
          text="Coming soon"
          color="warning"
          iconColor="neutral"
          variant="light"
          size="small"
          icon="actions-mono"
          className="px-2"
        />
      )}
      {!step.comingSoon && (
        <Tippy
          content={ALERT_BILLER_CLEARINGHOUSE_HINT}
          disabled={!disableToggle}
          className="tippy-dark"
          placement="left">
          <div onClick={(e) => e.stopPropagation()} tabIndex={disableToggle ? 0 : undefined}>
            <Switch
              checked={!!step.enabled}
              onChange={(enabled) => onUpdate({ enabled })}
              disabled={disableToggle}
              size="small"
              dataQa={`eligibility-step-toggle-${step.field}`}
            />
          </div>
        </Tippy>
      )}
    </div>
  );

  const content = renderEligibilityStepContent({ step, onUpdate });

  return (
    <Accordion
      title={stepHeader}
      rightContent={stepRightContent}
      defaultOpen={!!step.comingSoon}
      className="flex-1 border-neutral-200 !shadow-none"
      contentClassName="bg-neutral-50">
      {content && (
        // Suspend row dragging while the pointer is over the expanded body so
        // embedded controls (the team-member Select) receive their clicks —
        <div
          className="flex flex-col gap-3"
          onMouseEnter={() => setDisableDragging?.(true)}
          onMouseLeave={() => setDisableDragging?.(false)}>
          {content}
        </div>
      )}
    </Accordion>
  );
};

export default EligibilityStepRow;
